import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CommonService } from 'src/app/services/common-services/common.service';

@Component({
  selector: 'app-link-sent-successfully',
  templateUrl: './link-sent-successfully.component.html',
  styleUrls: ['./link-sent-successfully.component.scss']
})
export class LinkSentSuccessfullyComponent implements OnInit{
  userEmail: string = '';
  constructor(private commonService: CommonService){

  }

  ngOnInit(): void {
    this.commonService.sharedData$.subscribe({next: (email: string)=>{
      this.userEmail = email;
      }})
  }
}
